<div *ngIf="eventForm" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
  <div class="bg-white p-6 rounded-lg w-full max-w-xl shadow-xl"(click)="$event.stopPropagation()">
    <h2 class="text-xl font-bold mb-4">
      {{ eventData ? "academy.calendar-edit-event"  : 'academy.calendar-new-event' | translate}}
    </h2>

    <form [formGroup]="eventForm" (ngSubmit)="submit()" class="space-y-4">
      <input formControlName="title" class="w-full border rounded p-2" placeholder="Título" />

      <textarea formControlName="description" class="w-full border rounded p-2" placeholder="Descripción"></textarea>

      <div class="grid grid-cols-2 gap-4">
        <input formControlName="startDate" type="date" class="border rounded p-2" />
        <input formControlName="endDate" type="date" class="border rounded p-2" />
        <input formControlName="startHour" type="time" class="border rounded p-2" />
        <input formControlName="endHour" type="time" class="border rounded p-2" />
      </div>

        <label class="flex items-center space-x-2 mt-4">
            <input type="checkbox" formControlName="notification" />
            <span>{{"academy.calendar-has-notification" | translate}}</span>
        </label>

        <div *ngIf="eventForm.get('notification')?.value" class="mt-2">
            <label class="block text-sm font-medium text-gray-700 mb-1">{{"academy.calendar-reminder-minutes" | translate}}</label>
            <select formControlName="reminderMinutes" class="border rounded p-2 w-full">
                <option [value]="5">5 {{'academy.calendar-minutes-before' | translate}}</option>
                <option [value]="10">10 {{'academy.calendar-minutes-before' | translate}}</option>
                <option [value]="15">15 {{'academy.calendar-minutes-before' | translate}}</option>
                <option [value]="20">20 {{'academy.calendar-minutes-before' | translate}}</option>
                <option [value]="30">30 {{'academy.calendar-minutes-before' | translate}}</option>
            </select>
        </div>
      <label class="flex items-center space-x-2">
        <input type="checkbox" formControlName="isRecurring" />
        <span>{{"academy.calendar-is-recurring" | translate}}</span>
      </label>

      <div  [hidden]="eventForm && !eventForm?.get('isRecurring')?.value">
        <label class="block text-sm font-medium text-gray-700 mb-1">{{"academy.calendar-frecuency" | translate}}</label>
        <select formControlName="recurrence" class="border rounded p-2 w-full">
            <option [value]="0">{{"academy.calendar-frecuency-none" | translate}}</option>
            <option [value]="1">{{"academy.calendar-frecuency-daily" | translate}}</option>
            <option [value]="2">{{"academy.calendar-frecuency-weekly" | translate}}</option>
            <option [value]="3">{{"academy.calendar-frecuency-monthly" | translate}}</option>
        </select>
        <label *ngIf="eventForm && eventForm?.get('recurrence')?.value != 0" class="block text-sm font-medium text-gray-700 mt-4 mb-1">{{"academy.calendar-interval" | translate}}</label>
        <div class="grid grid-cols-1 gap-2 mt-4">
            <select *ngIf="eventForm && eventForm?.get('recurrence')?.value == 1" formControlName="interval" class="border rounded p-2 w-full">
                <option [value]="1">{{"academy.calendar-each-day" | translate}}</option>
                <option [value]="2">{{"academy.calendar-each-two-days" | translate}}</option>
            </select>
            <select *ngIf="eventForm && eventForm?.get('recurrence')?.value == 2" formControlName="interval" class="border rounded p-2 w-full">
                <option [value]="1">{{"academy.calendar-each-week" | translate}}</option>
                <option [value]="2">{{"academy.calendar-each-two-weeks" | translate}}</option>
            </select>
            <select *ngIf="eventForm && eventForm?.get('recurrence')?.value == 3" formControlName="interval" class="border rounded p-2 w-full">
                <option [value]="1">{{"academy.calendar-each-month" | translate}}</option>
                <option [value]="2">{{"academy.calendar-each-two-months" | translate}}</option>
            </select>
        </div>
        <!-- <input formControlName="interval" type="number" class="border rounded p-2 w-full" min="1" step="1" /> -->
        <div class="grid grid-cols-1 gap-2 mt-4" *ngIf="eventForm && eventForm?.get('recurrence')?.value == 2">
            <label class="block text-sm font-medium text-gray-700 mb-1">{{"academy.calendar-weekdays" | translate}}</label>
            <div class="grid grid-cols-4 gap-2">
                <label *ngFor="let day of weekdays">
                <input type="checkbox"
                        [value]="day.value"
                        (change)="toggleWeekday(day.value, $event)"
                        [checked]="(eventForm?.get('byweekday')?.value || []).includes(day.value)" />
                {{ day.label }}
                </label>
            </div>
        </div>
        <!-- Puedes hacer checkboxes o multiselect para byweekday -->
      </div>

      <div class="flex justify-end space-x-2">
        <button type="button" class="px-4 py-2 bg-gray-200 rounded" (click)="close.emit()">Cancelar</button>
        <button type="submit" class="px-4 py-2 bg-blue-600 text-white rounded">Guardar</button>
      </div>
    </form>
  </div>
</div>
